import * as InfoCard from './components/InfoCard.css';

export default {
	InfoCard
};
